import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {InfoSistema} from './info-sistema';
import {catchError} from 'rxjs/operators';
import {handleError} from '../../util/error-util';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  url = "/internal/v1/sistema/info"

  constructor(private readonly http: HttpClient) { }

  getSystemInfo(): Observable<InfoSistema> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {headers};
    return this.http.get<InfoSistema>(`${this.url}`, options).pipe(catchError(handleError));
  }
}
